import { default as NextLink } from 'next/link'
import clsx from 'clsx'
import { Link2Icon } from 'lucide-react'

export const LinkComp = ({
  href,
  size = 13,
  variant,
  children,
  target = '_blank',
  rel = 'noopener noreferrer',
  ...props
}: {
  href: string
  children: React.ReactNode
  target?: string
  rel?: string
  variant?: 'primary' | 'secondary'
  size?: number
}) => {
  const variantStyles = {
    primary: 'hover:text-blue-600 hover:underline',
    secondary: 'hover:text-black-900 hover:underline',
  }

  const variantClass = variantStyles[variant || 'secondary']

  return (
    <NextLink
      href={href}
      target={target}
      rel={rel}
      className={clsx(
        'ds-gap-4 group flex items-center hover:cursor-pointer',
        variantClass,
        size,
      )}
      style={{ fontSize: size }}
      {...props}
    >
      {children}
      <Link2Icon className="ds-w-12 ds-h-12 invisible group-hover:visible" />
    </NextLink>
  )
}
